import { Component, OnInit, Inject, AfterViewInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalendarServiceDetailService } from 'app/services/calendar-service-detail.service';
import { ApiService } from 'app/services/api.service';
//import { URLSearchParams } from '@angular/http';

export class CalendarYearDetailServiceViewModel {
  public service: any;
  public date: any;
  public liturgyType: number;
}


@Component({
  selector: 'app-calendar-year-detail-service',
  templateUrl: './calendar-year-detail-service.component.html',
  styleUrls: ['./calendar-year-detail-service.component.css']
})
export class CalendarYearDetailServiceComponent implements OnInit {

  public isLoading: boolean;
  public serviceDetail: any;
  public urlToHtmlPreview: string;
  public title: string;

  public serviceName: string;
  public service_LectionarySource: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CalendarYearDetailServiceViewModel, 
    private dialog: MatDialogRef<CalendarYearDetailServiceComponent>,
    public calendarServiceDetailSvc: CalendarServiceDetailService,
    public apiSvc: ApiService
    ) {}

  ngOnInit() { 
  }

  ngAfterViewInit() {

    this.urlToHtmlPreview  = this.getHtmlUrl();

     
    console.log("GetDetail", this.data);


    this.isLoading = true;
    var dateStr = this.formatDateStr();
    this.title = this.getTitle();
    
    this.serviceName = this.data.service.Name;

    this.service_LectionarySource = this.data.service.LectionarySource_Name;

    this.calendarServiceDetailSvc.getService(this.data.service.Id, this.data.date.LectionaryYear, this.data.date.DailyOfficeLectionaryYear, this.data.liturgyType, dateStr).then(s=>{
      this.serviceDetail = s; 
      console.log("GET SERVICE RESULTS", s);


      this.isLoading = false;
    }).catch((err) => {
      this.isLoading = false;
      this.dialog.close();
    });
  }

  public getTitle(): string {
    if (this.data.liturgyType == 1) {
      return "Holy Eucharist";
    } else if (this.data.liturgyType == 2) {
      return "Morning Prayer";
    } else if (this.data.liturgyType == 3) {
      return "Evening Prayer";
    }
  }

  public getHtmlUrl() { 

    var url = "../assets/proper-preview.html"; 

    //Resetting the value in local storage in case it was removed. Looking to avoid the user from logging back in and/or reloading the app
    this.apiSvc.assignBaseUrlToLocalStorage();
 
    var options = {
      ServiceId: this.data.service.Id,
      Date: this.formatDateStr(),
      LiturgyType: this.data.liturgyType 
    };

    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }

    var url = url + "?" + params.toString();
    console.log(url);

    return url;
  }

  private formatDateStr(): string {
    return this.data.date.DateMonth + "/" + this.data.date.DateDay + "/" + this.data.date.DateYear;
  }

  private getBaseUrl(): string {
    var url = window.location.origin;
    return url;
  }


  private joinArray(values: any[]) {
 
    var titles = values.map(x=>x.Title);
    
    const groupedValues = new Map();
    titles.forEach((title) => {  
         if (groupedValues.get(title) == null) {
          groupedValues.set(title, [title]);
         } 
    });

    var results = Array.from(groupedValues.keys());

    return results.join(" or ");
  }

}

